"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const core_1 = require("@angular/core");
const common_1 = require("../../../@inax/common");
const plc_1 = require("../../../@inax/plc");
const sql_1 = require("../../../@inax/sql");
const script_1 = require("../../../@inax/script");
const logger_1 = require("../../../@inax/logger");
const domain_1 = require("./domain");
let InaxMotionService = 
/**
 * Service class to communicate with inax to handle plc motions
 * @class InaxMotionService
 */
class InaxMotionService {
    constructor(_inaxPlc, _inaxSql, _inaxScript, _logger, _configuration) {
        this._inaxPlc = _inaxPlc;
        this._inaxSql = _inaxSql;
        this._inaxScript = _inaxScript;
        this._logger = _logger;
        this._configuration = _configuration;
        this._tableName = "Motions";
        this._tableQuery = "BlockNum = {}";
        this._scriptUnitName = "MotionScripts";
        this._inizializedPropertyName = "MotionDataInitialized";
        this._groupName = "motion";
        this._dataBlockName = "DB_InaxSafety";
        this._hmiId = -1;
    }
    get MappingName() {
        return this._dataBlockName;
    }
    get HmiId() {
        return this._hmiId;
    }
    set HmiId(value) {
        this._hmiId = value;
    }
    /**
     * Fetch the number of motions from the database.
     * @method getNumberOfMotionsForBlockAsync
     * @param {String} plcId
     * @param {Number} block
     */
    getNumberOfMotionsForBlockAsync(plcId, block) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._inaxSql.count(this._tableName, this._tableQuery.replace("{}", String(block))).toPromise();
        });
    }
    /**
     * Fetch the motions from the database.
     * @method getMotionsForBlockAsync
     * @param {String} plcId
     * @param {Number} block
     */
    getMotionsForBlockAsync(plcId, block) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = new Array();
            let initialized = yield this._inaxScript.getScriptPropertyValueInServerContext(this._scriptUnitName, this._inizializedPropertyName).toPromise();
            if (initialized) {
                let motions = yield this._inaxSql.query(this._tableName, "BlockNum=" + block, "pageNumber, RowNumber", "FinalPositions").toPromise();
                for (let motion of motions) {
                    motion.UdtModiondata = new domain_1.UdtMotion();
                    motion.OtherHmiId = false;
                }
                return motions;
            }
            return result;
        });
    }
    /**
    * create a proxy to subscribe to datachange callbacks from the safe plc block.
    * @method createSafeBlockHeaderProxy
    * @param {String} plcId
    * @param { Array<string>}variables
    */
    createSafeBlockHeaderProxy(plcId, variables) {
        return this._inaxPlc.createEventProxy(this._groupName, plcId, this._dataBlockName, variables);
    }
    /**
    * create a proxy to subscribe to datachange callbacks of the given motion.
    * @method createMotionProxy
    * @param {IMotionEx} motion
    * @param {Array<string>}variables
    */
    createMotionProxy(motion, variables) {
        return this._inaxPlc.createEventProxy(this._groupName, motion.Plc, motion.MappingName, variables);
    }
    /**
     * This methods creates a proxy for the datachange mechanism of the operand values.
     * @method createOperandValueProxy
     * @param {String} plcId
     * @param {IFinalPositionEx} finalPosition
     */
    createOperandValueProxy(motion) {
        //TODO
        return null;
    }
    /**
     * Start a selection of a motion, if a selection is active you could start moving the selected motion.
     * @method selectMotion
     * @param {String} plcId
     * @param {IMotionEx} motion
     */
    selectMotion(motion, info = "") {
        if (motion == null)
            throw "motion is null";
        return this._inaxScript.invokeInClientContext(this._scriptUnitName, "StartSelection", [motion.Plc, motion.MappingName, this._hmiId, motion.SlotNumber, info]);
    }
    /**
     * Stop the selection of a motion.
     * @method selectMotion
     * @param {String} plcId
     * @param {IMotionEx} motion
     */
    deselectMotion(motion) {
        if (motion == null)
            throw "motion is null";
        return this._inaxScript.invokeInClientContext(this._scriptUnitName, "StopSelection", [motion.Plc, motion.Id, this._hmiId, motion.SlotNumber]);
    }
    /**
     * Signals selection is going on. (if selected, this method should be called all n milliseconds)
     * @method signalOngoingSelection
     * @param {IMotionEx} motion
     * @param {MovingDirection} direction
     */
    signalOngoingSelection(motion) {
        if (motion == null)
            throw "motion is null";
        this._inaxScript.setScriptPropertyInClientContext(this._scriptUnitName, "SelectedSlotId", motion.SlotNumber);
    }
    /**
     * Start moving a motion. This is only available, if the motion is currently selected.
     * @method startMoving
     * @param {String} plcId
     * @param {IMotionEx} motion
     * @param {MovingDirection} direction
     */
    startMoving(motion, direction) {
        if (motion == null)
            throw "motion is null";
        if (direction == domain_1.MovingDirection.None)
            throw "invalid direction";
        return this._inaxScript.invokeInClientContext(this._scriptUnitName, "StartMoving", [motion.Plc, motion.MappingName, direction, this._hmiId, motion.SlotNumber]);
    }
    /**
     * Stops moving of the motion.
     * @method stopMoving
     * @param {String} plcId
     * @param {IMotionEx} motion
     * @param {MovingDirection} direction
     */
    stopMoving(motion, direction) {
        if (motion == null)
            throw "motion is null";
        return this._inaxScript.invokeInClientContext(this._scriptUnitName, "StopMoving", [motion.Plc, motion.MappingName, direction, this._hmiId, motion.SlotNumber]);
    }
    /**
     * Signals moving is going on. (if moving is running this method should be called all n milliseconds)
     * @method signalOngoingMovement
     * @param {IMotionEx} motion
     * @param {MovingDirection} direction
     */
    signalOngoingMovement(motion, direction) {
        if (motion == null)
            throw "motion is null";
        if (direction == domain_1.MovingDirection.None)
            throw "invalid direction";
        this._inaxScript.setScriptPropertyInClientContext(this._scriptUnitName, `PressedButton${Number(direction)}SlotId`, motion.SlotNumber);
    }
    /**
     * This method is called to permit a running takeover for the given motion.
     * @method stopMoving
     * @param {IMotionEx} motion
     */
    permitTakeover(motion) {
        if (motion == null)
            throw "motion is null";
        this._inaxScript.executeInClientContext(this._scriptUnitName, "TakeoverAction", [motion.Plc, motion.SlotNumber, true]);
    }
    /**
     * This method is called to refuse a running takeover for the given motion.
     * @method stopMoving
     * @param {IMotionEx} motion
     */
    refuseTakeover(motion) {
        if (motion == null)
            throw "motion is null";
        this._inaxScript.executeInClientContext(this._scriptUnitName, "TakeoverAction", [motion.Plc, motion.SlotNumber, false]);
    }
};
InaxMotionService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [plc_1.InaxPlcService,
        sql_1.InaxSqlService,
        script_1.InaxScriptService,
        logger_1.InaxLoggerService,
        common_1.InaxConfiguration])
], InaxMotionService);
exports.InaxMotionService = InaxMotionService;
